import React from 'react'
import {useHistory} from 'react-router-dom'


import edit_icon from '../../assets/images/icons/edit-icon.png'


const InputField = (props)=>{
    const history = useHistory()


    const handleEdit = ()=>{
        history.push({
            pathname: props.path,
            state:{
                application:  props.state,
                isMember: props.isMember
            } 
        })
    }

    return(
    <div className="review-card-container">
        <div className="reveiew-card-header">
            <span>{props.title}</span>
           {!props.hasEdit && <div className="edit-ctn" onClick={handleEdit}>
                <img src={edit_icon}/>
                <span>Edit</span>
            </div>}
        </div>
        {props.children}
        <div className="seperator"></div>
    </div>

    )
}

export default InputField